import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  id: {
    nav: {
      links: [
        { label: "Cerita", id: "story" },
        { label: "Coaching", id: "coaching" },
        { label: "Program", id: "programs" },
        { label: "Panduan Gratis", id: "free-guide" },
        { label: "Hasil", id: "results" },
        { label: "Kontak", id: "contact" },
      ],
      bookCall: "Booking Call",
      menuLabel: "Buka menu",
    },
    hero: {
      overline: "Platform Coaching Resmi",
      subtitle: "Coaching Online Elite",
      paragraph:
        "Dari nol sampai transformasi terbesar dalam hidupmu. Bersama berarti tidak pernah sendirian — dan itulah inti dari sistem kami. Presisi. Kontrol. Eksekusi.",
      ctaPrimary: "Mulai Perjalananmu",
      ctaSecondary: "Dapatkan Panduan Gratis",
      stats: [
        { value: "500+", label: "Atlet Terbimbing" },
        { value: "10+", label: "Tahun Pengalaman" },
        { value: "12", label: "Minggu Sistem Terbukti" },
        { value: "24 Jam", label: "Respons Prioritas" },
      ],
      scrollLabel: "Gulir ke bawah",
    },
    marquee: ["PRESISI", "KONTROL", "EKSEKUSI", "DISIPLIN", "KONSISTENSI", "BERSAMA"],
    story: {
      chapter: "Cerita Kami",
      titleA: "Dari Nol Menjadi",
      titleB: "Sistem",
      titleC: "Yang Terbukti",
      imgCaption: "Dibangun Dari Nol",
      imgSub: "Berdiri di Jakarta — Coaching ke Seluruh Dunia",
      p1: "FitBersama lahir di sebuah gym kecil. Tanpa mesin mahal. Tanpa jalan pintas. Hanya sebuah barbel, buku catatan, dan satu keyakinan: tidak ada yang seharusnya berjuang sendirian.",
      p2a: "Bersama",
      p2b: " berarti tidak pernah sendirian. Setiap atlet yang kami bimbing mendapatkan hal yang sama — program yang dibangun khusus untuk tubuhnya, umpan balik jujur setiap minggu, dan standar yang tidak pernah turun. Ini bukan motivasi. Ini standar.",
      p3: "Kebanyakan orang sudah berlatih keras, tapi hanya mencapai setengah dari potensinya. Bukan karena tidak berusaha — tapi karena tidak punya sistem. Semua yang kami bangun berdiri di atas tiga hal:",
      pillars: ["PRESISI", "KONTROL", "EKSEKUSI"],
      quote:
        "Kamu tidak naik ke level motivasimu. Kamu jatuh ke level sistemmu. Jadi kami membangun sistem yang lebih baik — bersama.",
      cta: "Gabung Tim Kami",
    },
    coaching: {
      chapter: "Coaching 1:1",
      titleA: "Coaching",
      titleB: "Personal",
      intro:
        "Satu standar. Coaching 1:1 elite yang dibangun sepenuhnya untukmu — tubuhmu, levelmu, targetmu. Kami hanya membimbing sejumlah atlet dalam satu waktu agar setiap orang mendapatkan perhatian kelas dunia.",
      langNote: "Coaching tersedia dalam Bahasa Indonesia dan English.",
      standard: {
        tag: "Sekali Bayar · 12 Minggu",
        name: "The Standard",
        sub: "Langkah pertamamu masuk ke dalam sistem.",
        specs: [
          ["Pembayaran", "Sekali bayar"],
          ["Durasi", "Program 12 minggu"],
          ["Pengiriman", "Lewat email"],
          ["Check-in", "Seminggu sekali"],
        ],
        choose: "Pilih Paketmu",
        packages: [
          { id: "training", label: "Training Saja", price: "Rp 999.000" },
          { id: "nutrition", label: "Nutrisi Saja", price: "Rp 999.000" },
          { id: "bundle", label: "Bundel Training + Nutrisi", price: "Rp 1.799.000" },
        ],
        features: [
          "Program training atau nutrisi personal yang dibangun khusus untuk tubuhmu",
          "Disesuaikan dengan level, jadwal, dan targetmu",
          "Dikirim dalam 48–72 jam lewat email",
          "Check-in mingguan lewat email selama 12 minggu",
        ],
        cta: "Ambil Programku",
        note: "Kami akan menghubungimu dalam 24 jam dengan formulir intake.",
      },
      elite: {
        badge: "Paling Populer",
        tag: "Langganan Bulanan · Ditagih Tiap 4 Minggu",
        name: "The Elite",
        sub: "Akses penuh. Hasil penuh. Jalur langsung ke coach.",
        specs: [
          ["Pembayaran", "Tiap 4 minggu"],
          ["Durasi", "Berjalan terus"],
          ["Pengiriman", "WhatsApp"],
          ["Check-in", "Mingguan via WhatsApp"],
        ],
        billing: "Siklus Tagihan",
        price: "Rp 3.499.000",
        per: "/ 4 minggu",
        features: [
          "Program training + nutrisi + suplemen sepenuhnya personal",
          "Check-in mingguan lewat WhatsApp",
          "Program diperbarui setelah setiap check-in bila perlu",
          "Koreksi teknik gerakan",
          "Bimbingan mindset dan strategi kompetisi",
          "Respons prioritas dalam 24 jam",
        ],
        cta: "Gabung Tim Elite",
        note: "Bisa berhenti kapan saja sebelum tanggal tagihan berikutnya.",
      },
    },
    programs: {
      chapter: "Program",
      titleA: "Program",
      titleB: "Kami",
      intro:
        "Dibangun dari pengalaman nyata. Terbukti pada atlet sungguhan. Sekali bayar — programmu dikirim langsung ke email.",
      available: "Tersedia Sekarang",
      coming: "Segera Hadir",
      buy: "Beli Sekarang",
      soon: "Segera",
      footnote: "Sekali bayar · PDF dikirim lewat email · Checkout aman",
      toastTitle: "Checkout aman segera hadir",
      toastBody: (title) =>
        `Daftar ke panduan gratis di bawah dan kami akan kabari begitu "${title}" resmi dibuka.`,
      items: [
        {
          id: "mindset",
          title: "The FitBersama Mindset",
          subtitle: "Menang Sebelum Bertanding",
          description:
            "Kerangka mental di balik setiap transformasi. Sistem visualisasi, protokol disiplin, dan mindset yang membedakan mereka yang sekadar mulai — dan mereka yang benar-benar selesai.",
          price: "Rp 299.000",
          status: "available",
          img: "https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxneW0lMjB3ZWlnaHRzJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg4MTkwMjQ5fDA&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "ppl",
          title: "The 12-Week Standard",
          subtitle: "Program PPL Lengkap",
          description:
            "Sistem push-pull-legs di balik ratusan transformasi. Keseimbangan, simetri, detail, dan kontrol otot — cetak biru lengkap, minggu demi minggu.",
          price: "Rp 249.000",
          status: "available",
          img: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=1200&auto=format&fit=crop",
        },
        {
          id: "zero",
          title: "Built From Zero",
          subtitle: "Sistem Fondasi Pemula",
          description:
            "Tanpa pengalaman? Tidak masalah. Fondasi 16 minggu yang mencakup pola gerakan, pembentukan kebiasaan, dan dasar nutrisi — sistem yang kami harap kami punya di hari pertama.",
          price: "Rp 349.000",
          status: "coming",
          img: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1200&auto=format&fit=crop",
        },
        {
          id: "peak",
          title: "Peak Week, Simplified",
          subtitle: "Protokol Kondisioning Lengkap",
          description:
            "Tampil penuh, kering, dan siap — setiap saat. Struktur langkah demi langkah untuk fase akhir: strategi carb-up, pengaturan air, waktu makan, dan eksekusi penuh.",
          price: "Rp 299.000",
          status: "coming",
          img: "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?q=80&w=1200&auto=format&fit=crop",
        },
      ],
    },
    guide: {
      chapter: "Panduan Gratis · Tanpa Syarat",
      titleA: "3 Kesalahan Yang",
      titleB: "Membunuh",
      titleC: "Progresmu",
      intro:
        "Kesalahan training dan nutrisi yang kami lihat mencuri bertahun-tahun progres para lifter — dan apa yang harus dilakukan sebagai gantinya. Langsung dari 10+ tahun coaching dan 500+ atlet. Gratis, sekarang juga.",
      label: "Email Terbaikmu",
      placeholder: "kamu@email.com",
      submit: "Kirim Panduannya",
      sending: "Mengirim...",
      error: "Masukkan alamat email yang valid.",
      noSpam: "Tanpa spam. Bisa berhenti berlangganan kapan saja.",
      successTitle: "Kamu Terdaftar.",
      successBody: "Panduanmu sedang dikirim ke",
      successNote: "Cek inbox kamu — dan folder spam, untuk jaga-jaga.",
      download: "Unduh Panduanmu",
    },
    universe: {
      chapter: "FitBersama Universe",
      titleA: "Lainnya Dari",
      titleB: "FitBersama",
      intro: "Performa. Gaya. Pemulihan. Semua dalam satu standar.",
      comingBadge: "Segera Hadir",
      communityCta: "Gabung Komunitas",
      notify: "Kabari Saat Rilis",
      items: [
        {
          id: "community",
          tag: "Gabung Gratis",
          title: "Komunitas FitBersama",
          subtitle: "Latihan Bersama",
          description:
            "Komunitas privat berisi atlet-atlet dengan standar yang sama. Tantangan mingguan, cek teknik, dan akuntabilitas — karena bersama berarti tidak pernah sendirian.",
          img: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwY29hY2glMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODgxOTAyNDl8MA&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "wear",
          tag: "Segera Hadir",
          title: "FB Wear",
          subtitle: "Activewear Premium",
          description:
            "Pakaian performa untuk atlet yang hadir setiap hari. Tanpa kompromi — pada bahan, potongan, maupun standar.",
          img: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?q=80&w=1200&auto=format&fit=crop",
        },
        {
          id: "nutrition",
          tag: "Segera Hadir",
          title: "FB Nutrition",
          subtitle: "Suplemen Olahraga",
          description:
            "Suplemen kelas elite yang diformulasikan untuk mendukung performa dan pemulihan tingkat dunia. Diuji dan dipercaya oleh atlet kami sendiri lebih dulu.",
          img: "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?q=80&w=1200&auto=format&fit=crop",
        },
      ],
    },
    blog: {
      chapter: "Dari Blog",
      titleA: "Ilmu Dari",
      titleB: "Lapangan",
      intro: "Training · Nutrisi · Mindset",
      posts: [
        { id: 1, cat: "Training", title: "Membangun Punggung Siap Panggung", date: "Juni 2026", read: "7 menit" },
        { id: 2, cat: "Mindset", title: "Kemenangan Dimulai Sebelum Hari Pertama", date: "Juni 2026", read: "6 menit" },
        { id: 3, cat: "Persiapan Kompetisi", title: "Cara Peak Tanpa Menebak-nebak", date: "Juli 2026", read: "8 menit" },
        { id: 4, cat: "Training", title: "Kesalahan #1 Yang Membunuh Progresmu", date: "Juli 2026", read: "5 menit" },
        { id: 5, cat: "Coaching", title: "Kenapa Program Template Selalu Gagal", date: "Juli 2026", read: "6 menit" },
        { id: 6, cat: "Nutrisi", title: "Dasar Nutrisi Yang Benar-Benar Berhasil", date: "Juli 2026", read: "5 menit" },
      ],
    },
    results: {
      chapter: "Hasil Terbukti",
      titleA: "Orang Nyata.",
      titleB: "Sistem Nyata.",
      testimonials: [
        {
          name: "Rizky A.",
          tag: "The Standard · 12 Minggu",
          quote:
            "Dua tahun latihan tanpa hasil yang berarti. Dua belas minggu menjalankan program Standard dan akhirnya saya paham rasanya progresi yang terstruktur. Turun 9 kg, semua angkatan naik.",
        },
        {
          name: "Sarah M.",
          tag: "The Elite · 6 Bulan",
          quote:
            "Check-in mingguan lewat WhatsApp mengubah segalanya. Ada orang yang benar-benar menonton video latihan saya, mengoreksi teknik, menyesuaikan kalori. Ini kebalikan total dari program template.",
        },
        {
          name: "Dimas P.",
          tag: "The Elite · Persiapan Kompetisi",
          quote:
            "Kompetisi pertama, trofi pertama. Protokol peak week-nya saja sudah sebanding dengan setiap rupiah yang dikeluarkan. Saya naik panggung dengan kondisi penuh, kering, dan tenang — karena tidak ada lagi tebak-tebakan.",
        },
        {
          name: "Putri L.",
          tag: "The Standard · Bundel",
          quote:
            "Yang paling mengejutkan: program 'sekali bayar' ini terasa sangat personal. Setiap gerakan ada alasannya. Setiap menu cocok dengan jadwal saya. Saya berhenti meniru influencer dan mulai benar-benar progres.",
        },
      ],
      faqTitleA: "Pertanyaan,",
      faqTitleB: "Terjawab",
      faqIntro:
        "Semua yang perlu kamu tahu sebelum berkomitmen. Masih ragu? Booking call gratis di bawah ini.",
      faqs: [
        {
          q: "Bagaimana cara kerja coaching online ini?",
          a: "Setelah bergabung, kamu menerima formulir intake tentang target, jadwal, peralatan, dan riwayat latihanmu. Programmu dibangun dari situ — tidak pernah dari template. Atlet Standard check-in mingguan lewat email; atlet Elite check-in mingguan lewat WhatsApp dengan review video teknik.",
        },
        {
          q: "Saya pemula total. Apakah ini cocok untuk saya?",
          a: "Sangat cocok. Sekitar setengah atlet kami mulai dari nol. Programmu dibangun sesuai levelmu — sistem kami bisa mengiringi dari squat pertamamu sampai persiapan kompetisi.",
        },
        {
          q: "Coaching-nya memakai bahasa apa?",
          a: "Coaching dan semua program tersedia dalam Bahasa Indonesia dan English. Kamu bisa memilihnya saat mengisi formulir intake.",
        },
        {
          q: "Kapan dan bagaimana saya menerima program saya?",
          a: "Program Standard dikirim lewat email dalam 48–72 jam setelah formulir intake kamu lengkap. Atlet Elite menerima program pertama lewat WhatsApp dalam 48 jam.",
        },
        {
          q: "Bisakah saya berhenti dari langganan Elite?",
          a: "Bisa. Kamu bisa berhenti kapan saja sebelum tanggal tagihan berikutnya dan tidak akan ditagih lagi. Pembayaran pertamamu mencakup satu siklus penuh 4 minggu.",
        },
      ],
    },
    contact: {
      chapter: "Kontak · Booking Call",
      titleA: "Berhenti Menebak.",
      titleB: "Mulai Eksekusi.",
      intro:
        "Booking call gratis 15 menit atau kirimkan targetmu. Kami membalas setiap pesan dalam 24–48 jam.",
      emailLabel: "Email",
      waLabel: "WhatsApp",
      waValue: "Atlet Elite · jalur langsung",
      name: "Nama",
      namePlaceholder: "Namamu",
      email: "Email",
      emailPlaceholder: "kamu@email.com",
      interest: "Saya Tertarik Dengan",
      interestPlaceholder: "Pilih topik",
      goals: "Targetmu",
      goalsPlaceholder: "Ceritakan kondisimu sekarang dan tujuan yang ingin kamu capai...",
      submit: "Kirim Pesan",
      sending: "Mengirim...",
      topics: [
        "Booking Call Gratis",
        "The Standard — Training Saja",
        "The Standard — Nutrisi Saja",
        "The Standard — Bundel Training + Nutrisi",
        "The Elite — Coaching Bulanan",
        "Bantuan Program",
        "Pertanyaan Umum",
      ],
      successTitle: "Pesan Diterima.",
      successThanks: "Terima kasih,",
      successReply: "Kami akan membalas ke",
      successWithin: "dalam 24–48 jam.",
      sendAnother: "Kirim Pesan Lain",
      toastOkTitle: "Pesan diterima",
      toastOkBody: "Kami akan membalas dalam 24–48 jam.",
      toastErrTitle: "Terjadi kesalahan",
      toastErrBody: "Periksa kembali datamu dan coba lagi.",
    },
    footer: {
      privacy: "Kebijakan Privasi",
      terms: "Syarat & Ketentuan",
      updated: "Terakhir diperbarui: Juli 2026",
      rights: "© 2026 FitBersama. Seluruh hak cipta dilindungi.",
      tagline: "Presisi · Kontrol · Eksekusi — Bersama.",
      privacyBody: `1. SIAPA KAMI
Website ini dioperasikan oleh FitBersama. Untuk pertanyaan terkait privasi, hubungi kami di hello@fitbersama.com.

2. DATA YANG KAMI KUMPULKAN
Saat kamu mengirim formulir kontak atau booking, kami mengumpulkan nama, alamat email, dan target yang kamu bagikan. Saat kamu bergabung ke daftar panduan gratis, kami mengumpulkan alamat emailmu.

3. BAGAIMANA KAMI MENGGUNAKAN DATAMU
Datamu hanya digunakan untuk memberikan layanan yang kamu minta — program coaching, program latihan, dan produk digital. Kami tidak menjual, membagikan, atau menyewakan data pribadimu kepada pihak ketiga mana pun.

4. KOMUNIKASI EMAIL
Setelah pembelian atau pendaftaran, kami mengirim email transaksional berisi program atau tautan unduhanmu. Kami tidak mengirim email marketing tanpa persetujuanmu.

5. HAKMU
Kamu berhak mengakses, memperbaiki, atau menghapus data pribadimu kapan saja. Hubungi hello@fitbersama.com untuk menggunakan hak tersebut.`,
      termsBody: `1. PENERIMAAN
Dengan membeli produk atau layanan apa pun dari FitBersama, kamu menyetujui syarat dan ketentuan ini sepenuhnya.

2. PRODUK DIGITAL (PDF)
Semua program PDF adalah produk digital yang dikirim lewat email. Karena sifat produk digital, semua penjualan bersifat final dan tidak dapat dikembalikan setelah tautan unduhan diakses. Membagikan, menyebarkan, atau menjual kembali program apa pun sangat dilarang.

3. COACHING — THE STANDARD
The Standard adalah pembayaran satu kali untuk program personal 12 minggu. Pembayaran tidak dapat dikembalikan setelah program dikirim. Program dikirim dalam 48–72 jam setelah formulir intake kamu lengkap.

4. COACHING — THE ELITE
The Elite adalah langganan berulang yang ditagih setiap 4 minggu. Dengan berlangganan, kamu berkomitmen pada satu siklus tagihan penuh. Pembayaran pertamamu tidak dapat dikembalikan. Kamu dapat berhenti kapan saja sebelum tanggal tagihan berikutnya dan tidak akan ditagih lagi.

5. PENAFIAN HASIL
Hasil dari program latihan dan nutrisi berbeda pada setiap individu. FitBersama tidak menjamin hasil tertentu. Konsultasikan dengan tenaga medis sebelum memulai program latihan atau nutrisi baru.

6. KONTAK
Untuk pertanyaan atau sengketa, hubungi kami di hello@fitbersama.com. Kami berusaha membalas dalam 48 jam.`,
    },
    admin: {
      back: "← Kembali ke situs",
      titleB: "Admin",
      refresh: "Muat Ulang",
      error: "Gagal memuat data dari API.",
      enquiries: "Pesan Masuk",
      subscribers: "Pelanggan Panduan Gratis",
      cols: { date: "Tanggal", name: "Nama", email: "Email", topic: "Topik", message: "Pesan", source: "Sumber" },
      emptyEnquiries: "Belum ada pesan masuk.",
      emptySubscribers: "Belum ada pelanggan.",
      locale: "id-ID",
    },
  },
  en: {
    nav: {
      links: [
        { label: "Story", id: "story" },
        { label: "Coaching", id: "coaching" },
        { label: "Programs", id: "programs" },
        { label: "Free Guide", id: "free-guide" },
        { label: "Results", id: "results" },
        { label: "Contact", id: "contact" },
      ],
      bookCall: "Book a Call",
      menuLabel: "Toggle menu",
    },
    hero: {
      overline: "The Official Coaching Platform",
      subtitle: "Elite Online Coaching",
      paragraph:
        "From zero to the biggest transformation of your life. Bersama means together — and that is the whole system. Precision. Control. Execution.",
      ctaPrimary: "Start Your Journey",
      ctaSecondary: "Get The Free Guide",
      stats: [
        { value: "500+", label: "Athletes Coached" },
        { value: "10+", label: "Years Experience" },
        { value: "12-Week", label: "Proven Systems" },
        { value: "24h", label: "Priority Response" },
      ],
      scrollLabel: "Scroll down",
    },
    marquee: ["PRECISION", "CONTROL", "EXECUTION", "DISCIPLINE", "CONSISTENCY", "BERSAMA"],
    story: {
      chapter: "Our Story",
      titleA: "From Nothing To A",
      titleB: "System",
      titleC: "That Works",
      imgCaption: "Built From Zero",
      imgSub: "Est. Jakarta — Coaching Worldwide",
      p1: "FitBersama started in a small garage gym. No fancy machines. No shortcuts. Just a barbell, a notebook, and one belief: nobody should have to figure this out alone.",
      p2a: "Bersama",
      p2b: " means together. Every athlete we coach gets the same thing — a plan built for their body, honest weekly feedback, and a standard that never drops. Not motivation. A standard.",
      p3: "Most people work hard and still realize only half of their potential. Not because they don't try — because they don't have a system. Everything we build comes from three things:",
      pillars: ["PRECISION", "CONTROL", "EXECUTION"],
      quote:
        "You don't rise to the level of your motivation. You fall to the level of your system. So we build better systems — together.",
      cta: "Be Part Of The Team",
    },
    coaching: {
      chapter: "1:1 Coaching",
      titleA: "Personalised",
      titleB: "Coaching",
      intro:
        "One standard. Elite 1:1 coaching built entirely around you — your body, your level, your goal. We coach a limited number of athletes at a time so every single person gets world-class attention.",
      langNote: "Coaching available in English and Bahasa Indonesia.",
      standard: {
        tag: "One-Time Payment · 12 Weeks",
        name: "The Standard",
        sub: "Your first step into the system.",
        specs: [
          ["Payment", "One-time"],
          ["Duration", "12-week program"],
          ["Delivery", "By email"],
          ["Check-ins", "Once a week"],
        ],
        choose: "Choose Your Package",
        packages: [
          { id: "training", label: "Training Only", price: "Rp 999.000" },
          { id: "nutrition", label: "Nutrition Only", price: "Rp 999.000" },
          { id: "bundle", label: "Training + Nutrition Bundle", price: "Rp 1.799.000" },
        ],
        features: [
          "Personalised training or nutrition plan built for your body",
          "Customised to your level, schedule and goals",
          "Delivered within 48–72 hours via email",
          "One weekly email check-in for 12 weeks",
        ],
        cta: "Get My Program",
        note: "You will be contacted within 24 hours with your intake form.",
      },
      elite: {
        badge: "Most Popular",
        tag: "Monthly Subscription · Billed Every 4 Weeks",
        name: "The Elite",
        sub: "Full access. Full results. Direct line to your coach.",
        specs: [
          ["Payment", "Every 4 weeks"],
          ["Duration", "Ongoing"],
          ["Delivery", "WhatsApp"],
          ["Check-ins", "Weekly by WhatsApp"],
        ],
        billing: "Billing Cycle",
        price: "Rp 3.499.000",
        per: "/ 4 weeks",
        features: [
          "Fully personalised training + nutrition + supplements plan",
          "Weekly check-ins by WhatsApp",
          "Program updates after each check-in if needed",
          "Exercise form correction",
          "Mindset and competition strategy guidance",
          "Priority response within 24 hours",
        ],
        cta: "Join The Elite Team",
        note: "Cancel anytime before your next billing date.",
      },
    },
    programs: {
      chapter: "Programs",
      titleA: "The",
      titleB: "Programs",
      intro:
        "Built from real experience. Proven on real athletes. One-time purchase — your program delivered instantly by email.",
      available: "Available Now",
      coming: "Coming Soon",
      buy: "Buy Now",
      soon: "Soon",
      footnote: "One-time purchase · PDF delivered via email · Secure checkout",
      toastTitle: "Secure checkout is launching soon",
      toastBody: (title) =>
        `Join the free guide list below and we will notify you the moment "${title}" goes live.`,
      items: [
        {
          id: "mindset",
          title: "The FitBersama Mindset",
          subtitle: "Win Before You Begin",
          description:
            "The mental framework behind every transformation. Visualization systems, discipline protocols, and the mindset that separates those who start — and those who finish.",
          price: "Rp 299.000",
          status: "available",
          img: "https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxneW0lMjB3ZWlnaHRzJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg4MTkwMjQ5fDA&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "ppl",
          title: "The 12-Week Standard",
          subtitle: "Complete PPL Program",
          description:
            "The push-pull-legs system behind hundreds of transformations. Balance, symmetry, detail, and muscle control — the complete blueprint, week by week.",
          price: "Rp 249.000",
          status: "available",
          img: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=1200&auto=format&fit=crop",
        },
        {
          id: "zero",
          title: "Built From Zero",
          subtitle: "Beginner Foundation System",
          description:
            "No experience needed. A 16-week foundation covering movement patterns, habit building, and nutrition basics — the exact system we wish we had on day one.",
          price: "Rp 349.000",
          status: "coming",
          img: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1200&auto=format&fit=crop",
        },
        {
          id: "peak",
          title: "Peak Week, Simplified",
          subtitle: "Complete Conditioning Protocol",
          description:
            "Show up full, dry, and ready — every time. Step-by-step structure for the final stretch: carb-up approach, water strategy, meal timing, and full execution.",
          price: "Rp 299.000",
          status: "coming",
          img: "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?q=80&w=1200&auto=format&fit=crop",
        },
      ],
    },
    guide: {
      chapter: "Free Guide · No Catch",
      titleA: "3 Mistakes",
      titleB: "Killing",
      titleC: "Your Progress",
      intro:
        "The training and nutrition errors we see costing lifters years of progress — and exactly what to do instead. Straight from 10+ years of coaching and 500+ athletes. Get it free, right now.",
      label: "Your Best Email",
      placeholder: "you@email.com",
      submit: "Get The Guide",
      sending: "Sending...",
      error: "Please enter a valid email address.",
      noSpam: "No spam. Unsubscribe anytime.",
      successTitle: "You're In.",
      successBody: "Your guide is on its way to",
      successNote: "Check your inbox — and your spam folder, just in case.",
      download: "Download Your Guide",
    },
    universe: {
      chapter: "The FitBersama Universe",
      titleA: "More From",
      titleB: "FitBersama",
      intro: "Performance. Style. Recovery. All under one standard.",
      comingBadge: "Coming Soon",
      communityCta: "Join The Community",
      notify: "Notify Me At Launch",
      items: [
        {
          id: "community",
          tag: "Join Free",
          title: "FitBersama Community",
          subtitle: "Train Together",
          description:
            "A private community of athletes following the same standard. Weekly challenges, form checks, and accountability — because bersama means together.",
          img: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwY29hY2glMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODgxOTAyNDl8MA&ixlib=rb-4.1.0&q=85",
        },
        {
          id: "wear",
          tag: "Coming Soon",
          title: "FB Wear",
          subtitle: "Premium Activewear",
          description:
            "Performance wear built for athletes who show up every day. No compromises — in fabric, fit, or standard.",
          img: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?q=80&w=1200&auto=format&fit=crop",
        },
        {
          id: "nutrition",
          tag: "Coming Soon",
          title: "FB Nutrition",
          subtitle: "Sports Supplements",
          description:
            "Elite-grade supplements formulated to support world-class performance and recovery. Tested and trusted by our own athletes first.",
          img: "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?q=80&w=1200&auto=format&fit=crop",
        },
      ],
    },
    blog: {
      chapter: "From The Blog",
      titleA: "Knowledge From",
      titleB: "The Floor",
      intro: "Training · Nutrition · Mindset",
      posts: [
        { id: 1, cat: "Training", title: "Build a Stage-Ready Back", date: "June 2026", read: "7 min" },
        { id: 2, cat: "Mindset", title: "Winning Starts Before Day One", date: "June 2026", read: "6 min" },
        { id: 3, cat: "Competition Prep", title: "How to Peak Without Guessing", date: "July 2026", read: "8 min" },
        { id: 4, cat: "Training", title: "The #1 Mistake Killing Your Progress", date: "July 2026", read: "5 min" },
        { id: 5, cat: "Coaching", title: "Why Cookie-Cutter Programs Fail", date: "July 2026", read: "6 min" },
        { id: 6, cat: "Nutrition", title: "Nutrition Basics That Actually Work", date: "July 2026", read: "5 min" },
      ],
    },
    results: {
      chapter: "Proven Results",
      titleA: "Real People.",
      titleB: "Real Systems.",
      testimonials: [
        {
          name: "Rizky A.",
          tag: "The Standard · 12 Weeks",
          quote:
            "I trained for two years with nothing to show for it. Twelve weeks on the Standard plan and I finally understand what structured progression actually feels like. Down 9kg, up on every lift.",
        },
        {
          name: "Sarah M.",
          tag: "The Elite · 6 Months",
          quote:
            "The weekly WhatsApp check-ins changed everything. Someone actually looking at my videos, correcting my form, adjusting my calories. It is the opposite of a cookie-cutter program.",
        },
        {
          name: "Dimas P.",
          tag: "The Elite · Competition Prep",
          quote:
            "First competition, first trophy. The peak week protocol alone was worth every rupiah. I stepped on stage full, dry, and calm — because there was zero guessing left.",
        },
        {
          name: "Putri L.",
          tag: "The Standard · Bundle",
          quote:
            "What surprised me most was how personal a 'one-time' program felt. Every exercise had a reason. Every meal fit my schedule. I stopped copying influencers and started making progress.",
        },
      ],
      faqTitleA: "Questions,",
      faqTitleB: "Answered",
      faqIntro:
        "Everything you need to know before you commit. Still unsure? Book a free call below.",
      faqs: [
        {
          q: "How does online coaching actually work?",
          a: "After you join, you receive an intake form covering your goals, schedule, equipment, and history. Your plan is built from that — never from a template. Standard athletes check in weekly by email; Elite athletes check in weekly by WhatsApp with video form review.",
        },
        {
          q: "I'm a complete beginner. Is this for me?",
          a: "Yes. Around half of our athletes start as beginners. Your plan is built to your level — the system scales from your first squat to competition prep.",
        },
        {
          q: "What language is coaching in?",
          a: "Coaching and all programs are available in both English and Bahasa Indonesia. You choose during your intake form.",
        },
        {
          q: "How and when do I receive my program?",
          a: "Standard programs are delivered by email within 48–72 hours of your completed intake form. Elite athletes receive their first plan by WhatsApp within 48 hours.",
        },
        {
          q: "Can I cancel the Elite subscription?",
          a: "Yes. You can cancel anytime before your next billing date and you will not be charged again. Your first payment commits you to one full 4-week cycle.",
        },
      ],
    },
    contact: {
      chapter: "Contact · Book A Call",
      titleA: "Stop Guessing.",
      titleB: "Start Executing.",
      intro:
        "Book a free 15-minute call or send us your goals. We reply to every message within 24–48 hours.",
      emailLabel: "Email",
      waLabel: "WhatsApp",
      waValue: "Elite athletes · direct line",
      name: "Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "you@email.com",
      interest: "I'm Interested In",
      interestPlaceholder: "Choose a topic",
      goals: "Your Goals",
      goalsPlaceholder: "Tell us where you are now and where you want to be...",
      submit: "Send Message",
      sending: "Sending...",
      topics: [
        "Book a Free Call",
        "The Standard — Training Only",
        "The Standard — Nutrition Only",
        "The Standard — Training + Nutrition Bundle",
        "The Elite — Monthly Coaching",
        "Program Support",
        "General Question",
      ],
      successTitle: "Message Received.",
      successThanks: "Thanks,",
      successReply: "We will reply to",
      successWithin: "within 24–48 hours.",
      sendAnother: "Send Another Message",
      toastOkTitle: "Message received",
      toastOkBody: "We will get back to you within 24–48 hours.",
      toastErrTitle: "Something went wrong",
      toastErrBody: "Please check your details and try again.",
    },
    footer: {
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      updated: "Last updated: July 2026",
      rights: "© 2026 FitBersama. All rights reserved.",
      tagline: "Precision · Control · Execution — Bersama.",
      privacyBody: `1. WHO WE ARE
This website is operated by FitBersama. For any privacy-related questions, contact us at hello@fitbersama.com.

2. WHAT DATA WE COLLECT
When you submit a contact or booking form, we collect your name, email address, and the goals you share with us. When you join our free guide list, we collect your email address.

3. HOW WE USE YOUR DATA
Your data is used solely to deliver the services you requested — coaching programs, training plans, and digital products. We do not sell, share, or rent your personal data to any third parties.

4. EMAIL COMMUNICATIONS
After a purchase or sign-up, we send transactional emails containing your program or download link. We do not send marketing emails without your consent.

5. YOUR RIGHTS
You have the right to access, correct, or delete your personal data at any time. Contact hello@fitbersama.com to exercise these rights.`,
      termsBody: `1. ACCEPTANCE
By purchasing any product or service from FitBersama, you agree to these terms and conditions in full.

2. DIGITAL PRODUCTS (PDFs)
All PDF programs are digital products delivered by email. Due to the nature of digital goods, all sales are final and non-refundable once the download link has been accessed. Sharing, redistributing, or reselling any program is strictly prohibited.

3. COACHING — THE STANDARD
The Standard is a one-time payment for a 12-week personalised program. Payment is non-refundable once the program has been delivered. Programs are delivered within 48–72 hours of receiving your completed intake form.

4. COACHING — THE ELITE
The Elite is a recurring subscription billed every 4 weeks. By subscribing you commit to one full billing cycle. Your first payment is non-refundable. You may cancel at any time before your next billing date and will not be charged again.

5. RESULTS DISCLAIMER
Results from training and nutrition programs vary by individual. FitBersama does not guarantee specific results. Consult a medical professional before beginning any new training or nutrition program.

6. CONTACT
For any questions or disputes, contact us at hello@fitbersama.com. We aim to respond within 48 hours.`,
    },
    admin: {
      back: "← Back to site",
      titleB: "Admin",
      refresh: "Refresh",
      error: "Failed to load data from the API.",
      enquiries: "Enquiries",
      subscribers: "Free Guide Subscribers",
      cols: { date: "Date", name: "Name", email: "Email", topic: "Topic", message: "Message", source: "Source" },
      emptyEnquiries: "No enquiries yet.",
      emptySubscribers: "No subscribers yet.",
      locale: "en-GB",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("fb-lang") || "id");

  useEffect(() => {
    localStorage.setItem("fb-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
